import { Request, Response, NextFunction } from 'express';
import { verifyAccessToken, AccessTokenPayload } from '../shared/jwt';
import { isTokenBlacklisted } from '../shared/redis';
import { AppError } from '../shared/errors/AppError';

export interface AuthRequest extends Request {
  user?: AccessTokenPayload;
}

export async function authMiddleware(req: AuthRequest, _res: Response, next: NextFunction) {
  try {
    const authHeader = req.headers.authorization;
    if (!authHeader?.startsWith('Bearer ')) {
      throw new AppError(401, 'No token provided');
    }

    const token = authHeader.substring(7);

    if (await isTokenBlacklisted(token)) {
      throw new AppError(401, 'Token revoked');
    }

    req.user = verifyAccessToken(token);
    next();
  } catch (err) {
    if (err instanceof AppError) return next(err);
    next(new AppError(401, 'Invalid or expired token'));
  }
}

export async function optionalAuthMiddleware(req: AuthRequest, _res: Response, next: NextFunction) {
  try {
    const authHeader = req.headers.authorization;
    if (authHeader?.startsWith('Bearer ')) {
      const token = authHeader.substring(7);
      if (!(await isTokenBlacklisted(token))) {
        req.user = verifyAccessToken(token);
      }
    }
  } catch {}
  next();
}

export function requireAuth(req: AuthRequest, res: Response, next: NextFunction) {
  if (!req.user) return next(new AppError(401, 'Unauthorized'));
  next();
}

